import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from 'src/auth/hooks';
import { useGetUserEntityPermissions } from 'src/api/users-entities';

import { useEntityContext } from '../hooks';

export default function EngagementGuard({ children }) {
  const router = useRouter();
  const { authenticated, user } = useAuthContext();
  const { entity } = useEntityContext();
  const [checked, setChecked] = useState(false);

  const { permissions, isLoading, error } = useGetUserEntityPermissions(user?.id, entity?.id);

  const check = useCallback(() => {
    if (!authenticated) {
      const searchParams = new URLSearchParams({ returnTo: window.location.pathname }).toString();
      const href = `${paths.auth.jwt.login}?${searchParams}`;
      router.replace(href);
      return;
    }

    if (isLoading) return;

    if (error || !permissions) {
      router.replace(paths.error.permissionDenied);
      return;
    }

    // Vérification spécifique pour Engagement
    if (!entity?.can_access_engagement) {
      router.replace(paths.error.permissionDenied);
      return;
    }

    if (user.role === 'superadmin') {
      setChecked(true);
      return;
    }

    if (!permissions[0].can_access_engagement) {
      router.replace(paths.error.permissionDenied);
      return;
    }

    setChecked(true);
  }, [authenticated, isLoading, error, permissions, user, entity, router]);

  useEffect(() => {
    check();
  }, [check]);

  if (!checked) return null;

  return <>{children}</>;
}

EngagementGuard.propTypes = {
  children: PropTypes.node,
};
